import produce from 'immer';
import { ActionTypes } from '../actions/subscribe';

export const initialState = {
    email: '',
    errorMessage: '',
    isAlready: false,
    isError: false,
    isLoading: false,
};

/* eslint-disable no-param-reassign */
function appSubscribeReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.CHANGE_EMAIL:
                draft.isError = false;
                draft.email = action.email;
                return draft;
            case ActionTypes.CHANGE_IS_ALREADY:
                draft.isAlready = true;
                return draft;
            case ActionTypes.CHANGE_ERROR_MESSAGE:
                draft.errorMessage = action.errorMessage;
                return draft;
            case ActionTypes.CHANGE_IS_ERROR:
                draft.isError = action.isError;
                return draft;
            case ActionTypes.CHANGE_IS_LOADING:
                draft.isLoading = action.isLoading;
                return draft;
            default:
                return draft;
        }
    });
}

export default appSubscribeReducer;
